const USERSNAP_GLOBAL_KEY = 'https://widget.usersnap.com/global/load/09d29634-a11a-4ee5-b142-4aa7ffca3020';

export const initUsersnap = () => {
    (window as any).onUsersnapCXLoad = function (api: any) {
        api.init();
    };
    const script = document.createElement('script');
    script.defer = true;
    script.src = `${USERSNAP_GLOBAL_KEY}?onload=onUsersnapCXLoad`;
    document.head.appendChild(script);
};
